export type Interest = {
    id: string
    label: string
}

/** What a call-back request can be about. The id doubles as the `tema` query value. */
export const INTERESTS: Interest[] = [
    { id: 'hele-svenn', label: 'Hele Svenn' },
    { id: 'befaring', label: 'Befaring' },
    { id: 'kalkulasjon', label: 'Kalkulasjon' },
    { id: 'ressursplanlegger', label: 'Ressursplanlegger' },
    { id: 'kvalitetssikring', label: 'Kvalitetssikring' },
    { id: 'hms', label: 'HMS-system' },
    { id: 'timeregistrering', label: 'Timeregistrering' },
    { id: 'sentral-godkjenning', label: 'Sentral godkjenning' },
    { id: 'integrasjoner', label: 'Integrasjoner' },
    { id: 'priser', label: 'Priser og avtale' }
]

export const interestLabel = (id: string | null | undefined): string | null =>
    INTERESTS.find(interest => interest.id === id)?.label ?? null
